import { ActionOption } from 'components/ActionPopover/ActionPopover';
import { pathsV2Creators } from 'core/services/navigation/usePathsV2';
import { TrackingEventName } from 'services/tracking/constants';

type SourcingGetAnalyseInviteColumnProps = {
  isDraft: boolean;
  candidateBatchId: string;
  sourcingEnabled: boolean;
  internalSourcingEnabled: boolean;
  track: (event: string, properties?: Record<string, any>) => void;
};

export const sourcingGetAnalyseInviteColumn = ({
  isDraft,
  candidateBatchId,
  sourcingEnabled,
  internalSourcingEnabled,
  track
}: SourcingGetAnalyseInviteColumnProps): ActionOption[] => {
  if (isDraft) {
    return [];
  }

  if (internalSourcingEnabled) {
    return [
      {
        label: 'Source candidates',
        onClick: () => {
          track(TrackingEventName.AnalyseListFindCandidates, {
            candidateBatchId
          });
          const url = pathsV2Creators.ANALYSE_CANDIDATE_PROFILE_LIST({
            candidateBatchId
          });
          window.location.href = url;
        }
      }
    ];
  }

  if (sourcingEnabled) {
    return [
      {
        label: 'Source candidates',
        onClick: () => {
          track(TrackingEventName.AnalyseListFindCandidates, {
            candidateBatchId
          });
          const url = pathsV2Creators.ANALYSE_SOURCE_EXTERNAL_CANDIDATES({
            candidateBatchId
          });
          window.location.href = url;
        }
      }
    ];
  }

  return [];
};
